/*
 * @Author: DQL
 * @Date: 2022-06-29 15:16:47
 * @LastEditors: DQL
 * @LastEditTime: 2022-10-02 23:17:20
 * @Description: 自定义指令
 */
import Vue from 'vue';
import { HMCoreStoreService } from 'kestrel-core-ui';
import {
  GNMK_ROLES,
  hasGnmkRoles,
  hasAllGnmkRoles,
  isGnmkUser
} from '@/features/common/utils/gnmkRoles';

Vue.prototype.GNMK_ROLES = GNMK_ROLES;
Vue.prototype.hasGnmkRoles = hasGnmkRoles;
Vue.prototype.hasAllGnmkRoles = hasAllGnmkRoles;

/**
 * @description: 页面标题匹配菜单标题的修正指令
 * 指令使用方法：v-menu-title
 */
const menuTitle = {
  inserted (el, binding, vnode) {
    // 获取系统菜单树的子菜单
    const menuLeaf = HMCoreStoreService.getMenuState('appMenusLeaf');

    // 获取当前页面路径
    const currentPath = vnode.context.$route.fullPath;

    // 当前页面路径匹配的菜单
    const currentMenu = menuLeaf.filter(item => item.menuUrl === currentPath);

    if (currentMenu.length >= 1) {
      // 修改标题
      el.innerText = currentMenu[0].menuName;
    }
  }
};

Vue.directive('menuTitle', menuTitle);

// 授权角色的元素权限控制指令
const permissionElement2 = {
  inserted (el, binding, vnode) {
    const permission = binding.value.permission ? binding.value.permission : binding.value;
    const permissionsElements = HMCoreStoreService.getUserState('elementCode');
    const isPermission = permissionsElements.includes(permission);
    if (!isPermission) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
};

Vue.directive('permissionElement2', permissionElement2);

/**
 * GNMK 角色元素显示控制（无任一指定角色则移除节点）
 * 用法：v-gnmk-role="'RWGLY'" 或 v-gnmk-role="['RWGLY','SJGLY']"
 * 需满足任一角色即可显示；若需全部满足请用模板内 hasAllGnmkRoles
 */
const gnmkRole = {
  inserted (el, binding) {
    const raw = binding.value;
    const roles = Array.isArray(raw) ? raw : (raw != null && raw !== '' ? [raw] : []);
    if (!roles.length || !hasGnmkRoles(...roles)) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
};

Vue.directive('gnmkRole', gnmkRole);

const cascaderClickSelect = {
  inserted (el, binding, vnode) {
    const cascader = vnode.componentInstance;
    const popper = cascader && cascader.$refs && cascader.$refs.popper;

    if (!popper) return;

    const handleClick = event => {
      const target = event.target;
      if (target.tagName === 'INPUT') return;

      let node = target;
      let insideCheckbox = false;
      while (node && node !== popper) {
        if (node.classList && node.classList.contains('el-cascader-node')) break;
        if (node.classList && node.classList.contains('el-checkbox')) insideCheckbox = true;
        node = node.parentNode;
      }

      if (!node || node === popper || node.classList.contains('is-disabled')) return;
      // 多选节点里是可见的 el-checkbox，点方框时外层 <label class="el-checkbox"> 已把点击转发给内部 input，
      // 这里再转发一次会把刚切好的选中状态切回去，表现为「方框点不动」；单选的 radio 被样式隐藏，不受影响。
      if (insideCheckbox) return;

      const input = node.querySelector('input');
      // 悬停展开时 Element UI 不再绑定节点点击事件，转发到原生控件以复用其选中逻辑。
      if (input) input.click();
    };

    popper.addEventListener('click', handleClick);
    el.__cascaderClickSelect = { popper, handleClick };
  },
  unbind (el) {
    const handler = el.__cascaderClickSelect;
    if (handler) {
      handler.popper.removeEventListener('click', handler.handleClick);
      delete el.__cascaderClickSelect;
    }
  }
};

Vue.directive('cascader-click-select', cascaderClickSelect);

export {
  GNMK_ROLES,
  hasGnmkRoles,
  hasAllGnmkRoles,
  isGnmkUser
};
